/**
 * Какой экран показывать. Единственная причина, по которой этот флаг вообще есть.
 *
 * Новый экран написан под второй протокол и живёт рядом со старым, а не вместо
 * него. Ветка с ним сливается в `main`, не меняя ни одного пикселя на проде:
 * боевая сборка идёт без `VITE_UI`, и `main.tsx` монтирует прежнее дерево.
 * Откат нового экрана — это одна переменная сборки, а не revert через полрепозитория.
 */

export const UI_NEXT = String(import.meta.env.VITE_UI ?? '').trim() === 'next';
